import { BrowserModule } from '@angular/platform-browser'
import { ErrorHandler, NgModule } from '@angular/core'
import { StoreModule } from '@ngrx/store'
import { EffectsModule } from '@ngrx/effects'
import { StoreDevtoolsModule } from '@ngrx/store-devtools'
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular'
import { SplashScreen } from '@ionic-native/splash-screen'
import { StatusBar } from '@ionic-native/status-bar'
import { ViewModel } from '../view-model'
import { reducer, ActionCreator } from '../services/action.service'
import { UIEventHub } from '../services/event.service'
import { RestClient } from '../services/rest-client.service'
import { SystemMessageService } from '../services/system-message.service'
import { App } from './app.component'
import { CmnfncBaseModule } from '../features/cmnfnc-base/cmnfnc-base.module'
import { CmnfncBaseInitialState } from '../features/cmnfnc-base/cmnfnc-base-view-model'
import {
  AngularMaterialModule,
  CommonComponentsModule,
  LoginPageModule,
  ConfirmDialogPageModule,
  CoreModule,
  GlobalErrorHandler,
  SystemErrorPageModule,
  ApiBaseService,
  LoadingService,
  AutoReloadService,
  TranslateMultipleFileLoader
} from '@ar2/common'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { LoadingModule } from 'ngx-loading'
import { TranslateModule, TranslateLoader } from '@ngx-translate/core'
import { Http, HttpModule } from '@angular/http'

/**
 * アプリケーションモジュール
 * @author nabla2.metamodel.generator
 */
@NgModule({
  declarations: [
    App,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    IonicModule.forRoot(App, { preloadModules: true }, 
{
  links: [
    { loadChildren: '../features/cmnfnc-base/pages/plncmm10000sc00-00/plncmm10000sc00-00.component.page.module.ngfactory#Plncmm10000sc0000PageModuleNgFactory', name: 'cmnfnc-base-plncmm10000sc00-00', segment: 'dashboard/dashboard', priority: 'low', defaultHistory: [] }
  ]
}),
    StoreModule.forRoot(
      { viewModel: reducer },
      { initialState: {
          viewModel: {
            cmnfnc_base: CmnfncBaseInitialState,
            errorMessages: [],
            modalErrorMessages: [],
            codeDefinitions: {}
          }
        }
      }
    ),
    EffectsModule.forRoot([]),
    CmnfncBaseModule,
    CoreModule,
    AngularMaterialModule,
    CommonComponentsModule,
    LoginPageModule,
    ConfirmDialogPageModule,
    SystemErrorPageModule,
    LoadingModule,
    HttpModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: TranslateMultipleFileLoader,
        deps: [Http]
      }
    }),
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    App,
  ],
  providers: [
    ActionCreator,
    UIEventHub,
    LoadingService,
    RestClient,
    SystemMessageService,
    StatusBar,
    SplashScreen,
    ApiBaseService,
    AutoReloadService,
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
  ]
})
export class AppModule {}


// WEBPACK FOOTER //
// ./src/app/app.module.ts